<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { BMPGL, } from "./components/views/dpi1920_1080/components/LinYiMap/utils"
let ak = "oLf54HhrIy1vAVKRrukSBiFPEHQPOkrA"
export default {
  mounted () {
    // BMPGL(ak)
  }
}
</script>

<style >
@import "../static/css/main.css";
@import "../static/css/lv.css";
@import "../static/css/hezeMain.css";
@import "../static/css/miles.css";
@import "../static/css/dy.css";
@import "../static/css/styles_1920_1080.css";
</style>



// WEBPACK FOOTER //
// src/App.vue